var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-view"},[_c('Leftbar'),_c('RouterView'),_c('Ipc',{on:{"setTheme":_vm.setTheme,"setLang":_vm.setLang}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }